import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import '../../../CSS/dashboard.css'
import ReusableButton from '../../../SharedComponents/Button/Button'
import ReusableTextBox from '../../../SharedComponents/Textbox/Textbox'
import Loading from '../../../Images/loading.gif'
import '../../../CSS/global.css' 
import './DashboardAdminCleaningCompanies.css'
import { destroySession } from '../../../Utility/Utility';
import * as DashboardAdminCleaningCompaniesConstant from './DashboardAdminCleaningCompaniesConstant'
import { VendorGetAllCleanersCompanies } from "../../../CleanersDashboardAdminAPI/CleanersAdminGetCompaniesApi";
import { CleanersAdminAddUpadateCompany } from "../../../CleanersDashboardAdminAPI/CleanersAdminAddUpdateComapnyAPi";
import { CleanersAdminDeleteCompany } from "../../../CleanersDashboardAdminAPI/CleanersAdminDeleteCompanyApi";
import { IoIosClose, IoMdSearch } from "react-icons/io";
import { FaExclamationTriangle } from "react-icons/fa";
import 'font-awesome/css/font-awesome.min.css';
import  AlertIcon  from '../../../Images/Alert.png'
import { CloseIcon } from '../../../Images/CloseIcon.svg'
import Modal from 'react-modal';
import { FaRegEdit } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai";
import { IconContext } from "react-icons";
import DashboardCleanersAdminHeader from '../../../CleanersDashboardComponents/Shared/DashboardCleanersAdminHeader/DashboardCleanersAdminHeader'
const $ = require('jquery')



class DashboardAdminModifySchedule extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            redirectError400: false,
            redirectError401: false,
            redirectError404: false,
            redirectError500: false,
            CompanyFileLogs: [],
            modalIsOpen: false,
            modalIsOpenEdit: false,
            modalIsOpenDelete: false,
            companyName: "",
            companyEmail: "",
            companyEmpty: false,
            emailEmpty: false,
            CompanyExists: false,
            companyEditEmpty : false,
            NoPrivilege: true,
            Id: '',
            EmailPolicy : false,
            NoData : false,
            EmailNotValid : false,
            EmailEditEmpty : false,
            NoDataSuperAdmin : false,
            DeleteId : ''

        }
        this.loadCompanyLogs = this.loadCompanyLogs.bind(this);
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.openModalEdit = this.openModalEdit.bind(this);
        this.afterOpenModalEdit = this.afterOpenModalEdit.bind(this);
        this.closeModalEdit = this.closeModalEdit.bind(this);
        this.openModalDelete = this.openModalDelete.bind(this);
        this.afterOpenModalDelete = this.afterOpenModalDelete.bind(this);
        this.closeModalDelete = this.closeModalDelete.bind(this);
    }

    componentWillMount() {
       this.setState({
        Role : sessionStorage.getItem('role')
       }) 

        this.loadCompanyLogs();
    }
    loadCompanyLogs() {
        this.setState({
            loading: true
        })
        let CompanyFileLogs = []
        let UserId = sessionStorage.getItem('userId')
        let TokenDataApi = sessionStorage.getItem('token');
        const AuthStr = 'bearer '.concat(TokenDataApi);
        VendorGetAllCleanersCompanies(UserId, AuthStr).then(res => {
            if (res.status == 200) {
                this.setState({
                    loading: false
                })
                let CompanyLogsArray = res.data.cleanerCompaniesList
                Object.keys(CompanyLogsArray).forEach(function (key) {
                    CompanyFileLogs.push({
                        Id: CompanyLogsArray[key].id,
                        CompanyName: CompanyLogsArray[key].companyName,
                        Email: CompanyLogsArray[key].email
                    })
                })
                this.setState({
                    CompanyFileLogs: CompanyFileLogs
                })
                if(CompanyLogsArray.length == 0) {
                    if(sessionStorage.getItem('role') == 3) {
                    this.setState({
                        NoDataSuperAdmin : true
                    })
                }
                else {
                    this.setState({
                        NoData : true
                    })
                }
                }
            }
            else if (res.status == 400) {
                this.setState({
                    redirectError400: true,
                    loading: false
                })
            }
            else if (res.status == 401) {
                this.setState({
                    redirectError401: true,
                    loading: false
                })
            }
            else if (res.status == 404) {
                this.setState({
                    redirectError404: true,
                    loading: false
                })
            }
            else if (res.status == 500) {
                this.setState({
                    redirectError500: true,
                    loading: false
                })
            }
        })

    }
    handleCompany = (e) => {
        this.setState({
            companyName: e.target.value,
            companyEmpty: false,
            CompanyExists: false,
            NoPrivilege: false,
            companyEditEmpty : false
        })
    }
    handleCompanyEmail = (e) => {
        this.setState({
            companyEmail: e.target.value,
            emailEmpty: false,
            EmailPolicy : false,
            EmailNotValid : false,
            EmailEditEmpty : false
        })
    }
    DeleteCompany = (e) => {
        let AuthData = {
            Id :this.state.DeleteId
        }
        let UserId = sessionStorage.getItem('userId')
        let TokenDataApi = sessionStorage.getItem('token');
        const AuthStr = 'bearer '.concat(TokenDataApi);
        CleanersAdminDeleteCompany(AuthData,UserId,AuthStr).then(res => {
            if(res.status == 200) {
                this.setState({
                    loading : false
                })
                this.closeModalDelete();
                this.loadCompanyLogs();
            }
            else if (res.status == 400) {
                this.setState({
                    redirectError400: true,
                    loading: false
                })
            }
            else if (res.status == 401) {
                this.setState({
                    redirectError401: true,
                    loading: false
                })
            }
            else if (res.status == 404) {
                    this.setState({
                        redirectError404: true,
                        loading: false
                    })
            }
            else if (res.status == 500) {
                this.setState({
                    redirectError500: true,
                    loading: false
                })
            }
        })
    }
    handleDeleteCompanies = (Id) => {
        this.setState({
            DeleteId : Id
        })
        this.openModalDelete();
    }

    handleEditComapnies = (CompanyName, Email, Id) => {
        this.openModalEdit();
        this.setState({
            Id: Id,
            companyName: CompanyName,
            companyEmail: Email,
        })


    }
    handleSaveEditCompany = (e) => {
        var Regex = /\S+@\S+\.\S+/;
        var Cond = Regex.test(this.state.companyEmail)
        var apiFlag = true
        let AuthData = {
            Id: this.state.Id,
            companyName: this.state.companyName,
            Email: this.state.companyEmail
        }
        if(AuthData.companyName == "") {
            this.setState({
                companyEditEmpty : true
            })
            apiFlag = false
        }
        if(AuthData.Email == "") {
            this.setState({
                EmailEditEmpty : true
            })
            Cond = true
            apiFlag = false
        }
        if(!(Cond)) {
            this.setState({
                EmailNotValid : true
            })
            apiFlag = false
        }
        if(apiFlag) {
        let UserId = sessionStorage.getItem('userId')
        let TokenDataApi = sessionStorage.getItem('token');
        const AuthStr = 'bearer '.concat(TokenDataApi);
        CleanersAdminAddUpadateCompany(AuthData, UserId, AuthStr).then(res => {
            if (res.status == 200) {
                this.setState({
                    loading : false,
                  modalIsOpenEdit : false  
                })
                this.loadCompanyLogs();
            }
            else if (res.status == 400) {
                this.setState({
                    redirectError400: true,
                    loading: false
                })
            }
            else if (res.status == 401) {
                this.setState({
                    redirectError401: true,
                    loading: false
                })
            }
            else if (res.status == 404) {
                if (res.data.description == "One or more errors occurred. (Cleaner Company already exits)") {
                    this.setState({
                        loading: false,
                        CompanyExists: true
                    })
                }
                else if (res.data.description == "One or more errors occurred. (User doesn't have  CleanerCompany privilege)") {
                    this.setState({
                        loading: false,
                        NoPrivilege: true
                    })
                }
               else {
                    this.setState({
                        redirectError404: true,
                        loading: false
                    })
                }
            }
            else if (res.status == 500) {
                this.setState({
                    redirectError500: true,
                    loading: false
                })
            }
        })
    }
    }
    handleSaveCompany = (e) => {
        this.setState({
            loading: true
        })
        var Regex = /\S+@\S+\.\S+/;
        var Cond = Regex.test(this.state.companyEmail)
        let AuthData = {
            Id: "0",
            CompanyName: this.state.companyName,
            Email: this.state.companyEmail
        }
        let apiFlag = true
        if (AuthData.CompanyName.length == 0) {
            this.setState({
                companyEmpty: true,
                loading: false,
            })
            apiFlag = false
        }
        if (AuthData.Email.length == 0) {
            this.setState({
                emailEmpty: true,
                loading: false
            })
            Cond = true
            apiFlag = false
        }
        if(!(Cond)) {
            this.setState({
                loading: false,
                EmailPolicy : true
            })
            apiFlag =  false
        }
        if (apiFlag) {
            let UserId = sessionStorage.getItem('userId')
            let TokenDataApi = sessionStorage.getItem('token');
            const AuthStr = 'bearer '.concat(TokenDataApi);
            CleanersAdminAddUpadateCompany(AuthData, UserId, AuthStr).then(res => {
                if (res.status == 200) {
                    this.setState({
                        loading: false,
                        modalIsOpen: false
                    })
                    this.loadCompanyLogs();
                }
                else if (res.status == 400) {
                    this.setState({
                        redirectError400: true,
                        loading: false
                    })
                }
                else if (res.status == 401) {
                    this.setState({
                        redirectError401: true,
                        loading: false
                    })
                }
                else if (res.status == 404) {
                    if (res.data.description == "One or more errors occurred. (Cleaner Company already exits)") {
                        this.setState({
                            loading: false,
                            CompanyExists: true
                        })
                    }
                    else if (res.data.description == "One or more errors occurred. (User doesn't have  CleanerCompany privilege)") {
                        this.setState({
                            loading: false,
                            NoPrivilege: true
                        })
                    }
                    else {
                        this.setState({
                            redirectError404: true,
                            loading: false
                        })
                    }
                }
                else if (res.status == 500) {
                    this.setState({
                        redirectError500: true,
                        loading: false
                    })
                }
            })
        }

    }
    openModal() {
        this.setState({
            modalIsOpen: true,
            emailEmpty: false,
            companyEmpty: false,
            CompanyExists: false,
            NoPrivilege: false,
            EmailPolicy : false,
            EmailNotValid : false,
            EmailEditEmpty : false
        })
    }

    afterOpenModal() {


    }

    closeModal() {
        this.setState({
            modalIsOpen: false
        });
    }
    openModalEdit() {
        this.setState({
            modalIsOpenEdit: true,
            companyEditEmpty: false,
            CompanyExists: false,
            NoPrivilege: false,
        })
    }

    afterOpenModalEdit() {


    }
    closeModalEdit() {
        this.setState({
            modalIsOpenEdit: false
        });
    }
    openModalDelete() {
        this.setState({
            modalIsOpenDelete: true
        })
    }

    afterOpenModalDelete() {


    }
    closeModalDelete() {
        this.setState({
            modalIsOpenDelete: false
        });
    }
    render() {
        var style = {
            color: '#edde36',
            fontSize: '48px'
          };
        if (this.state.redirectLogin) {
            return (<Redirect to={'/DashboardLogin'} />)
        }
        if (this.state.redirectError400) {
            return (<Redirect to={'/CleanersAdminDashboardError400'} />)
        }
        if (this.state.redirectError401) {
            return (<Redirect to={'/CleanersAdminDashboardError401'} />)
        }
        if (this.state.redirectError404) {
            return (<Redirect to={'/CleanersAdminDashboardError404'} />)
        }
        if (this.state.redirectError500) {
            return (<Redirect to={'/CleanersAdminDashboardError500'} />)
        }
        return (
            <div>
                <DashboardCleanersAdminHeader />
                {this.state.loading ?
                    <div className="overlay"><img src={Loading} alt="Loading" className="loadingSignOut" /></div> : null}
                <div className="Cleaning">
                {this.state.Role == 3 ? 
                 <ReusableButton className="NewCompany" onClick={this.openModal} buttonText={DashboardAdminCleaningCompaniesConstant.NewCleaningCompany}></ReusableButton> 
                : null }          
                    <div className="Companies">
                        <table className="CompaniesData">
                            <thead>
                                <tr>
                                    <th>{DashboardAdminCleaningCompaniesConstant.CompanyName}</th>
                                    <th>{DashboardAdminCleaningCompaniesConstant.CompanyEmail}</th>
                                    <th>{DashboardAdminCleaningCompaniesConstant.Coverage}</th>
                                    {this.state.Role == 3 ? 
                                    <th>{DashboardAdminCleaningCompaniesConstant.Action}</th>
                                      : null } 
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.CompanyFileLogs.map((x, key) =>
                                    <tr key={key}>
                                        <td>{x.CompanyName}</td>
                                        <td>{x.Email}</td>
                                        <td>{DashboardAdminCleaningCompaniesConstant.AcrossCoop}</td>
                                        {this.state.Role == 3 ? 
                                        <td><FaRegEdit className="EditIcon" onClick={(a, b, c) => this.handleEditComapnies(x.CompanyName, x.Email, x.Id)} /> &nbsp;&nbsp;&nbsp;
                                        <AiOutlineDelete className="EditIcon" onClick={(a) => this.handleDeleteCompanies(x.Id)} />
                                        </td>
                                        : null }
                                    </tr>
                                )}
                                           {this.state.NoData ? 
                              <tr>
                              <td colspan="3">{DashboardAdminCleaningCompaniesConstant.NoDataAvailable}</td></tr> : null
                        }
                         {this.state.Role == 3 ?
                         this.state.NoDataSuperAdmin ? 
                         <tr>
                         <td colspan="4">{DashboardAdminCleaningCompaniesConstant.NoDataAvailable}</td></tr> : null
                             : null}
                            </tbody>
                        </table>
                    </div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeModal}
                        className="ModalNewCompany"
                        contentLabel="Example Modal"
                        ariaHideApp={false}
                    >
                        <div className="IconModal"> <IconContext.Provider
                            value={{ color: 'grey' }}
                        >
                            <IoIosClose onClick={this.closeModal} />
                        </IconContext.Provider>
                        </div>
                        <div className="ModalHead">
                            <h3>{DashboardAdminCleaningCompaniesConstant.AddNewCompany}</h3>
                            <p className="Mandotory"><span className="mandatoryField">*</span>{DashboardAdminCleaningCompaniesConstant.Mandatory}</p>
                            <div className="WeekDaysCleaningComapnies">
                                <div className="Company"><p>{DashboardAdminCleaningCompaniesConstant.CompanyName}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="CompanyField" type="text" onChange={this.handleCompany} />
                                    {this.state.companyEmpty ? <span className="companyEmpty">{DashboardAdminCleaningCompaniesConstant.CompanyNull}</span> : null}
                                    {this.state.CompanyExists ? <span className="companyEmpty">{DashboardAdminCleaningCompaniesConstant.CompanyAlreadyExists}</span> : null}
                                    {this.state.NoPrivilege ? <span className="companyEmpty">{DashboardAdminCleaningCompaniesConstant.NoPermisssion}</span> : null}
                                </div>
                                <div className="CompanyEmail"><p>{DashboardAdminCleaningCompaniesConstant.CompanyEmail}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="CompanyField" type="text" onChange={this.handleCompanyEmail} />
                                    {this.state.emailEmpty ? <span className="companyEmpty">{DashboardAdminCleaningCompaniesConstant.EmailNull}</span> : null}
                                    {this.state.EmailPolicy ? <span className="companyEmpty">{DashboardAdminCleaningCompaniesConstant.EmailValid}</span> : null}
                                </div>
                            </div>
                            <div className="ButtonsNewCompanyModal">
                                <p className="CancelModal" onClick={this.closeModal}>{DashboardAdminCleaningCompaniesConstant.Cancel}</p>
                                <ReusableButton className="SaveFieldModal" buttonText="Save" onClick={this.handleSaveCompany} />
                            </div>
                        </div>
                    </Modal>
                    {/* Edit Cleaning Company*/}
                    <Modal
                        isOpen={this.state.modalIsOpenEdit}
                        onAfterOpen={this.afterOpenModalEdit}
                        onRequestClose={this.closeModalEdit}
                        className="ModalNewCompany"
                        contentLabel="Example Modal"
                        ariaHideApp={false}
                    >
                        <div className="IconModal"> <IconContext.Provider
                            value={{ color: 'grey' }}
                        >
                            <IoIosClose onClick={this.closeModalEdit} />
                        </IconContext.Provider>
                        </div>
                        <div className="ModalHead">
                            <h3>{DashboardAdminCleaningCompaniesConstant.EditCompany}</h3>
                            <p className="Mandotory"><span className="mandatoryField">*</span>{DashboardAdminCleaningCompaniesConstant.Mandatory}</p>
                            <div className="WeekDaysCleaningComapnies">
                            <div className="CompanyEdit">
                                <div className="NameField"><p>{DashboardAdminCleaningCompaniesConstant.CompanyName}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="CompanyEditField" type="text" value={this.state.companyName} onChange={this.handleCompany} />
                                    {this.state.companyEditEmpty ? <span className="companyEmpty">{DashboardAdminCleaningCompaniesConstant.CompanyNull}</span> : null}
                                    {this.state.CompanyExists ? <span className="companyEmpty">{DashboardAdminCleaningCompaniesConstant.CompanyAlreadyExists}</span> : null}
                                    {this.state.NoPrivilege ? <span className="companyEmpty">{DashboardAdminCleaningCompaniesConstant.NoPermisssion}</span> : null}
                                    </div>
                                    <div className="EmailField">
                                    <p>{DashboardAdminCleaningCompaniesConstant.CompanyEmail}<span className="mandatoryField">*</span></p>
                                    <ReusableTextBox className="CompanyEditField" type="text" value={this.state.companyEmail} onChange={this.handleCompanyEmail} />
                                    {this.state.EmailEditEmpty ? <span className="companyEmpty">{DashboardAdminCleaningCompaniesConstant.EmailNull}</span> : null}
                                    {this.state.EmailNotValid ? <span className="companyEmpty">{DashboardAdminCleaningCompaniesConstant.EmailValid}</span> : null}
                                    </div>
                                </div>
                            </div>
                            <div className="ButtonsEditCompanyModal">
                                <p className="CancelModal" onClick={this.closeModalEdit}>{DashboardAdminCleaningCompaniesConstant.Cancel}</p>
                                <ReusableButton className="SaveFieldModal" buttonText="Save" onClick={this.handleSaveEditCompany} />
                            </div>
                        </div>
                    </Modal>
    
                       {/* Delete Cleaning Company*/}
                       <Modal
                        isOpen={this.state.modalIsOpenDelete}
                        onAfterOpen={this.afterOpenModalDelete}
                        onRequestClose={this.closeModalDelete}
                        className="ModalNewDelete"
                        contentLabel="Example Modal"
                        ariaHideApp={false}
                    >
                        <div className="IconModal"> <IconContext.Provider
                            value={{ color: 'grey' }}
                        >
                            <IoIosClose onClick={this.closeModalDelete} />
                        </IconContext.Provider>
                        </div>
                        <div className="ModalHeadDelete">
                        <div className="Alert">
                        <img src={AlertIcon} width="60px" height="60px"/>
                        {/* <i class="fa fa-exclamation-triangle" style={style}></i> */}
                    
                        {/* <FaExclamationTriangle className=""/> */}
                            </div>
                            <h3>{DashboardAdminCleaningCompaniesConstant.Alert}</h3>
                            <div className="CompanyDelete">
                                <p >{DashboardAdminCleaningCompaniesConstant.Delete}</p>
                                </div>
                            <div className="ButtonsDeleteCompanyModal">
                            <ReusableButton className="DeleteModal" buttonText="Yes" onClick={this.DeleteCompany} />
                                <ReusableButton className="DeleteModal" buttonText="No" onClick={this.closeModalDelete} />
                            </div>
                        </div>
                    </Modal>
                </div>

            </div>
        )
    }
}

export default DashboardAdminModifySchedule
